import { STREAMLAIN_PHONE_WIDTH } from '@affine/core/modules/streamlain/shared/workspace-pane-layout';
import { useLayoutEffect, useState } from 'react';

/**
 * Whether the view is phone-sized. Its own width counts, not the window's: the sidebar or another
 * view of a split narrows it on a wide screen too.
 */
export function usePhoneSizedView(view: HTMLElement | null | undefined) {
  const [phone, setPhone] = useState(false);
  useLayoutEffect(() => {
    if (!view) return;
    const measure = () => {
      // A view without a width is not laid out yet.
      const { width } = view.getBoundingClientRect();
      setPhone(width > 0 && width <= STREAMLAIN_PHONE_WIDTH);
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(view);
    return () => observer.disconnect();
  }, [view]);
  return phone;
}
